import { render, staticRenderFns } from "./StudentLedger.vue?vue&type=template&id=8cca04fa&scoped=true"
import script from "./StudentLedger.vue?vue&type=script&lang=js"
export * from "./StudentLedger.vue?vue&type=script&lang=js"
import style0 from "./StudentLedger.vue?vue&type=style&index=0&id=8cca04fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cca04fa",
  null
  
)

export default component.exports